import type { AxiosRequestConfig } from 'axios';
import { request } from '@/admin/shared/api/httpClient';
import type { AdminGroup, AdminMe } from './types';

interface AdminMeRaw {
    user_id: number;
    email: string;
    is_superuser: boolean;
    admin_groups: AdminGroup[];
    display_name: string;
}

/** Fetches the current operator's admin context. */
export async function fetchAdminMe(): Promise<AdminMe> {
    // `suppressErrorToast` — тихий пробник: этот эндпоинт вызывается не только
    // из админ-панели, но и как boot-проверка «админ ли текущий пользователь»
    // для FE-навигации. Для обычного пользователя ответ 403 — штатное
    // состояние (стор выставит accessDenied), глобальный тост тут не нужен.
    const raw = await request<AdminMeRaw>({
        url: '/admin-api/me/',
        method: 'get',
        suppressErrorToast: true,
    } as AxiosRequestConfig & { suppressErrorToast: boolean });
    return {
        userId: raw.user_id,
        email: raw.email,
        isSuperuser: raw.is_superuser,
        adminGroups: raw.admin_groups,
        displayName: raw.display_name,
    };
}
